export default __webpack_public_path__ + "static/media/review10.72fe9264.jpg";